import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Recruiter from "./Recruiter";

@Model()
class RecruiterHiringHubScore extends ApplicationRecord {
  static jsonapiType = "recruiter_hiring_hub_scores";

  @Attr() score: number;

  @Attr() bufferedScore: number;

  @BelongsTo(Recruiter) recruiter: Recruiter;
}

export default RecruiterHiringHubScore;
